import { Controller } from "@hotwired/stimulus"

// The artist.tools reading form on the vet card (owner register 2026-09-30,
// SPT_Curator_Vetting_Gate_Plan.md section 3.7). Server truth: this only
// helps the person fill the form.
//
//   - Paste or drop puts the screenshot into the real file input, so the
//     ordinary form post carries it. A missing screenshot is refused by the
//     server in words; this never pretends one is attached.
//   - "Flagged" opens the box for the tool's exact words.
//   - A score under the minimum opens the "major artists" explanation.
//   - While a radio in this form has focus, S / M / J / U pick who is on
//     the list and B / F / N pick the bot label (one-key choices).
//   - Enter in any field submits (the browser's own form behavior).
export default class extends Controller {
  static targets = ["botLabel", "flaggedRow", "overrideRow", "score", "file", "dropzone", "dropLabel"]
  static values = { minScore: Number }

  connect() {
    this.keydown = this.handleKey.bind(this)
    this.element.addEventListener("keydown", this.keydown)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.keydown)
  }

  handleKey(event) {
    if (!event.target.matches("input[type=radio]")) return
    if (event.metaKey || event.ctrlKey || event.altKey) return
    const key = event.key.toUpperCase()
    const radio = this.element.querySelector(`input[type=radio][data-key="${key}"]`)
    if (!radio) return
    radio.checked = true
    radio.focus()
    event.preventDefault()
    event.stopPropagation()
    this.refresh()
  }

  // Called by the card's keyboard flow (B / F / N on a selected artist.tools slot).
  chooseBotLabel(key) {
    const radio = this.botLabelTargets.find(r => r.dataset.key === key)
    if (!radio) return
    radio.checked = true
    this.refresh()
    if (this.hasScoreTarget && key !== "N") this.scoreTarget.focus()
    else radio.focus()
  }

  refresh() {
    const label = (this.botLabelTargets.find(r => r.checked) || {}).value
    if (this.hasFlaggedRowTarget) this.flaggedRowTarget.hidden = label !== "flagged"
    if (this.hasOverrideRowTarget) {
      const score = this.hasScoreTarget ? parseFloat(this.scoreTarget.value) : NaN
      this.overrideRowTarget.hidden = !(label === "likely_bot_free" && !isNaN(score) && score < this.minScoreValue)
    }
  }

  paste(event) {
    const files = Array.from((event.clipboardData && event.clipboardData.files) || [])
    const image = files.find(f => f.type.startsWith("image/"))
    if (!image) return
    event.preventDefault()
    this.attach(image)
  }

  dragover(event) {
    event.preventDefault()
  }

  drop(event) {
    event.preventDefault()
    const files = Array.from((event.dataTransfer && event.dataTransfer.files) || [])
    const image = files.find(f => f.type.startsWith("image/"))
    if (image) this.attach(image)
  }

  picked() {
    const file = this.fileTarget.files && this.fileTarget.files[0]
    if (file) this.showName(file.name)
  }

  attach(file) {
    const transfer = new DataTransfer()
    transfer.items.add(new File([file], file.name || "artist-tools.png", { type: file.type }))
    this.fileTarget.files = transfer.files
    this.showName(file.name || "screenshot")
  }

  showName(name) {
    if (this.hasDropLabelTarget) this.dropLabelTarget.textContent = `Screenshot attached: ${name}`
  }
}
